export enum LinkedAccountType {
  LINKED_ACCOUNT,
  MOCK_SANDBOX,
}

export enum ApiTesterDirection {
  MERGE_TO_THIRD_PARTY = "merge-to-third-party",
  YOU_TO_MERGE = "you-to-merge",
}
